import { useCallback, useMemo, useRef, useState } from 'react';

// IL NOME SI CAMBIA DOVE SI LEGGE: nessuna icona, nessuna finestra. Il gesto è quello di ogni
// gestore di file — si sceglie la riga, e un secondo clic sul nome lo apre in scrittura — e vale
// per una riga dell'albero come per una tessera della griglia.
//
// IL GESTO STA IN UN POSTO SOLO perché è uno solo: due copie sarebbero due idee di che cosa fa
// Esc, e basta sistemarne una perché le due superfici si comportino diverso.
//
// L'ABBANDONO DEL CAMPO PUÒ ESSERE UNA CONFERMA O UNA RINUNCIA, e il tasto di fuga non può
// limitarsi a chiudere: chiudendo, il campo perde il fuoco e l'uscita scriverebbe comunque quello
// che c'era dentro. Il flag dice quale delle due è stata.
export const useInlineRename = () => {
    const [editingId, setEditingId] = useState<string | null>(null);
    const [draft, setDraft] = useState('');
    const cancelled = useRef(false);

    const start = useCallback((id: string, name: string) => {
        cancelled.current = false;
        setDraft(name);
        setEditingId(id);
    }, []);

    /**
     * Le props del campo. `onRename` riceve il nome nuovo: non arriva mai vuoto, né uguale a quello
     * di prima, né dopo una rinuncia.
     */
    const fieldProps = useCallback(
        (name: string, onRename: (value: string) => void) => ({
            autoFocus: true,
            value: draft,
            draggable: false,
            onFocus: (event: React.FocusEvent<HTMLInputElement>) => event.currentTarget.select(),
            onChange: (event: React.ChangeEvent<HTMLInputElement>) => setDraft(event.currentTarget.value),
            // Il campo sta dentro qualcosa che si può scegliere e trascinare: qui il clic scrive, e basta.
            onClick: (event: React.MouseEvent) => event.stopPropagation(),
            onMouseDown: (event: React.MouseEvent) => event.stopPropagation(),
            onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => {
                event.stopPropagation();
                if (event.key === 'Enter') event.currentTarget.blur();
                if (event.key === 'Escape') {
                    cancelled.current = true;
                    event.currentTarget.blur();
                }
            },
            onBlur: (event: React.FocusEvent<HTMLInputElement>) => {
                const value = event.currentTarget.value.trim();
                const gaveUp = cancelled.current;

                cancelled.current = false;
                setEditingId(null);

                if (!gaveUp && value && value !== name) onRename(value);
            }
        }),
        [draft]
    );

    // UN OGGETTO SOLO, e stabile finché non cambia niente: chi lo mette fra le dipendenze di un
    // `useCallback` non deve rifare il proprio lavoro a ogni disegno.
    return useMemo(() => ({ editingId, start, fieldProps }), [editingId, fieldProps, start]);
};
